import { gql } from '@apollo/client/core';
import { simplifiedQuoteItemFragment } from './simplified_quote_items';

export const simplifiedQuoteSectionFragment = gql`
  fragment SimplifiedQuoteSectionFragment on ai_simplified_quote_sections {
    id
    simplified_quote_id
    name
    description
    order_index
    is_option
    _created_at
    _updated_at
  }
`;

export const simplifiedQuoteSectionWithItemsFragment = gql`
  ${simplifiedQuoteSectionFragment}
  ${simplifiedQuoteItemFragment}
  fragment SimplifiedQuoteSectionWithItemsFragment on ai_simplified_quote_sections {
    ...SimplifiedQuoteSectionFragment
    simplified_quote_items {
      ...SimplifiedQuoteItemFragment
    }
  }
`;
